const luhn = require('fast-luhn')
const ocrRegex = /^\d+$/

/*
softCheck:
Företaget ska producera OCR-referensnummer med checksiffra.
Sista siffran ska vara checksiffra enligt 10-modul.
Det ska framgå av faktura eller motsvarande att OCR-referensnummer ska användas vid betalning till aktuellt bankgironummer.
Alla internetbanker kommer att uppmana betalaren att registrera ett korrekt OCR-referensnummer, men accepterar ett annat referensbegrepp efter en varning, eftersom avtalet har mjuk kontrollnivå.

hardCheck:
Företaget ska producera OCR-referensnummer med checksiffra.
Sista siffran ska vara checksiffra enligt 10-modul.
Det ska framgå av faktura eller motsvarande att ENBART OCR-referensnummer ska användas vid betalning till aktuellt bankgironummer.
Internetbanker kommer att uppmana betalaren att registrera ett korrekt OCR-referensnummer och accepterar bara referensnummer med korrekt checksiffra.
Betalningar med korrekt OCR-referensnummer redovisas enligt överenskommelse, normalt på fil.

lengthCheck:
Företaget ska producera OCR-referensnummer med både checksiffra och längdsiffra.
Sista siffran ska vara checksiffra enligt 10-modul.
Näst sista siffran är längdsiffran, d v s en entalssiffra som anger referensnumrets längd inklusive checksiffra.
Om referensnumret t ex är 24, 14 eller 4 tecken långt är den korrekta längdsiffran 4.
Det ska framgå av faktura eller motsvarande att ENBART OCR-referensnummer ska användas vid betalning till aktuellt bankgironummer.
Internetbanker kommer att uppmana betalaren att registrera ett korrekt OCR-referensnummer och accepterar bara referensnummer med korrekt checksiffra och korrekt längdsiffra.
Betalningar med korrekt OCR-referensnummer redovisas enligt överenskommelse, normalt på fil.

specificLengthCheck:
Företaget ska producera OCR-referensnummer, med checksiffra, som består av det antal siffror som regleras i avtalet.
Sista siffran ska vara checksiffra enligt 10-modul.
OCR-referensnumrets antal tecken (längd) ska stämma med någon av de i avtalet valda längderna (max 2 olika antal tecken kan väljas).
De valda längderna noteras i avtalet med företagets bank och information om de valda längderna distribueras till alla internetbanker från Bankgirot.
Det ska framgå av faktura eller motsvarande att ENBART OCR-referensnummer ska användas vid betalning till aktuellt bankgironummer.
Internetbanker kommer att uppmana betalaren att registrera ett korrekt OCR-referensnummer och accepterar bara referensnummer med korrekt checksiffra och en längd som stämmer med någon av de valda längderna i avtalet.
Betalningar med korrekt OCR-referensnummer redovisas enligt överenskommelse, normalt på fil.
*/

function luhnCheck(ocrNumber) {
  const valid = luhn(ocrNumber)
  if (!valid) return { valid, message: 'Invalid checksum digit' }
  return { valid }
}

const checks = {
  hardCheck: luhnCheck,
  lengthCheck: ocrNumber => {
    if (!luhn(ocrNumber)) {
      return luhnCheck(ocrNumber)
    }

    const ocrLength = ocrNumber.length
    const lengthDigit = ocrLength > 9 ? ocrLength % 10 : ocrLength
    const lengthCheckDigit = ocrNumber.substr(ocrLength - 2, 1)

    if (lengthCheckDigit !== lengthDigit) {
      return { valid: false, message: 'Invalid length checksum digit' }
    }

    return { valid: true }
  },
  specificLengthCheck: (ocrNumber, length1, length2) => {
    if (!luhn(ocrNumber)) {
      return luhnCheck(ocrNumber)
    }

    if (ocrNumber.length !== length1 && ocrNumber.length !== length2) {
      return { valid: false, message: `Invalid length. Should be either ${length1} or ${length2}.` }
    }

    return { valid: true }
  },
}

function validateOcr(
  ocrNumber,
  options = {
    hardCheck: false,
    lengthCheck: false,
    specificLengthCheck: false,
    specificLength1: false,
    specificLength2: false,
  }
) {
  const { hardCheck, lengthCheck, specificLengthCheck, specificLength1, specificLength2 } = options

  if (!ocrNumber) {
    return { valid: false, message: 'Invalid input' }
  }

  // Enbart siffror godkänns (0-9).
  if (!ocrNumber.match(ocrRegex)) {
    return { valid: false, message: 'Ocr should only contain digits (0-9)' }
  }

  //  OCR-referensnummer skall vara minst 2 tecken men max 25 tecken.
  if (ocrNumber.length < 2 || ocrNumber.length > 25) {
    return { valid: false, message: 'Ocr should be between 2 and 25 characters long.' }
  }

  if (hardCheck) {
    return checks.hardCheck(ocrNumber)
  }

  if (lengthCheck) {
    return checks.lengthCheck(ocrNumber)
  }

  if (specificLengthCheck) {
    if (!specificLength1 || !specificLength2) {
      return {
        valid: false,
        message: 'You need to supply both `specificLength1` and `specificLength2` to perform the specificLengthCheck.',
      }
    }
    if (specificLength1 < 2 || specificLength2 < 2 || specificLength1 > 25 || specificLength2 > 25) {
      return { valid: false, message: 'Both `specificLength1` and `specificLength2` need to be between 2 and 25.' }
    }
    return checks.specificLengthCheck(ocrNumber, specificLength1, specificLength2)
  }

  return { valid: true }
}

module.exports = function(opts) {
  return ocrNumber => {
    const res = validateOcr(ocrNumber, opts)
    return res.valid
  }
}
